export const ROW_GUTTER = 16;
export const SIDE_NAV_WIDTH = 236;
export const SIDE_NAV_COLLAPSED_WIDTH = 72;
// Remembers the sidebar's collapsed/expanded choice in this browser.
export const SIDE_NAV_COLLAPSED_STORAGE_KEY = 'side_nav_collapsed';
export const SIDE_NAV_LIGHT = 'SIDE_NAV_LIGHT';
export const SIDE_NAV_DARK = 'SIDE_NAV_DARK';
export const NAV_TYPE_SIDE = 'SIDE'
export const NAV_TYPE_TOP = 'TOP'
